import React, { useState, useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import crmApi, { money } from '../../utils/crmApi';
import useLiveRefresh from '../../utils/useLiveRefresh';

const DTYPE = { quote: 'Quotation', sales_order: 'Service Order', invoice: 'Invoice' };

export default function CrmApprovals() {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  function load() { crmApi.get('/my-approvals').then(setData).catch(() => setData({ count: 0, documents: [], forecasts: [], sends: [] })); }
  useEffect(() => { load(); }, []);
  useLiveRefresh(load);

  if (!data) return <div style={{ color: 'var(--muted)' }}>Loading…</div>;

  const empty = data.count === 0;
  const routeFor = t => t === 'invoice' ? 'invoices' : t === 'sales_order' ? 'sales-orders' : 'quotes';


  return (
    <div>
      <div style={{ marginBottom: '18px' }}>
        <h1 style={{ fontSize: '20px', fontWeight: '800' }}>My Approvals</h1>
        <p style={{ fontSize: '13px', color: 'var(--muted)' }}>Everything waiting for your action — confirmations, approvals and scheduled invoice sends.</p>
      </div>

      {empty && <div className="card" style={{ padding: '28px', textAlign: 'center', color: 'var(--muted)', fontSize: '14px' }}>You're all caught up — nothing is waiting for your approval.</div>}

      {data.documents.length > 0 && (
        <div style={{ marginBottom: '20px' }}>
          <div style={{ fontSize: '12px', fontWeight: '700', color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.6px', marginBottom: '10px' }}>Documents to approve ({data.documents.length})</div>
          {data.documents.map(d => (
            <div key={d.id} className="card" style={{ padding: '14px 18px', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }} onClick={() => navigate(`/crm/${routeFor(d.doc_type)}/${d.id}`)}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '13px', fontWeight: '800' }}>{DTYPE[d.doc_type] || d.doc_type} {d.doc_number}</div>
                <div style={{ fontSize: '12px', color: 'var(--muted2)' }}>{d.account_name || 'No account'} · {money(d.total, d.currency)}</div>
              </div>
              <span style={{ fontSize: '11px', fontWeight: '700', padding: '4px 10px', borderRadius: '99px', background: 'rgba(217,119,6,0.12)', color: '#D97706' }}>{d.stage_label}</span>
              <button className="btn btn-sm btn-primary">Open</button>
            </div>
          ))}
        </div>
      )}

      {data.sends && data.sends.length > 0 && (
        <div style={{ marginBottom: '20px' }}>
          <div style={{ fontSize: '12px', fontWeight: '700', color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.6px', marginBottom: '10px' }}>Invoices to send ({data.sends.length})</div>
          {data.sends.map(d => (
            <div key={d.id} className="card" style={{ padding: '14px 18px', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }} onClick={() => navigate(`/crm/invoices/${d.id}`)}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '13px', fontWeight: '800' }}>Invoice {d.doc_number}</div>
                <div style={{ fontSize: '12px', color: 'var(--muted2)' }}>{d.account_name || 'No account'} · {money(d.total, d.currency)}</div>
              </div>
              <span style={{ fontSize: '11px', fontWeight: '700', padding: '4px 10px', borderRadius: '99px', background: 'rgba(13,148,136,0.12)', color: '#0D9488' }}>Due to send</span>
              <button className="btn btn-sm btn-primary">Review &amp; send</button>
            </div>
          ))}
        </div>
      )}

      {data.month_freezes && data.month_freezes.length > 0 && (
        <div style={{ marginBottom: '20px' }}>
          <div style={{ fontSize: '12px', fontWeight: '700', color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.6px', marginBottom: '10px' }}>Monthly forecast freezes ({data.month_freezes.length})</div>
          {data.month_freezes.map((m, i) => (
            <div key={i} className="card" style={{ padding: '14px 18px', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }} onClick={() => navigate('/crm/forecast')}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '13px', fontWeight: '800' }}>Freeze {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][m.month - 1]} {m.year}</div>
                <div style={{ fontSize: '12px', color: 'var(--muted2)' }}>Rolling forecast month awaiting your approval</div>
              </div>
              <button className="btn btn-sm btn-primary">Open</button>
            </div>
          ))}
        </div>
      )}

      {data.forecasts.length > 0 && (
        <div>
          <div style={{ fontSize: '12px', fontWeight: '700', color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.6px', marginBottom: '10px' }}>Forecast targets to approve ({data.forecasts.length})</div>
          {data.forecasts.map(f => (
            <div key={f.id} className="card" style={{ padding: '14px 18px', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }} onClick={() => navigate('/crm/forecast')}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '13px', fontWeight: '800' }}>Annual Target {f.year}</div>
                <div style={{ fontSize: '12px', color: 'var(--muted2)' }}>Awaiting your approval to lock</div>
              </div>
              <button className="btn btn-sm btn-primary">Open</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
